<script lang="ts">
import type { MenuItem } from '@/types'
import { type PropType, defineComponent } from 'vue'

/**
 * AppFilterMenuItem
 */
export default defineComponent({
  props: {
    menuItem: {
      type: Object as PropType<MenuItem>,
      required: true,
    },
  },
  computed: {
    isAppIcon(): boolean {
      return (
        !!this.menuItem.icon &&
        Object.values(this.Icons)
          .map((icon) =>
            icon.replace('Icon', '').replace(' ', '').toLowerCase()
          )
          .includes(`${this.menuItem.icon}`.replace(' ', '').toLowerCase())
      )
    },
  },
})
</script>

<template>
  <div
    class="filter-menu-item flex flex-1 flex-col items-center justify-center border-b-4 p-3 hover:cursor-pointer"
  >
    <template v-if="menuItem.icon">
      <AppIcon v-if="isAppIcon" :icon="menuItem.icon" />
      <p v-else class="text-2xl">
        {{ menuItem.icon }}
      </p>
    </template>

    <div class="whitespace-nowrap text-center" :class="menuItem.class">
      {{ menuItem.text }}

      <div
        v-if="menuItem.subText"
        class="whitespace-nowrap"
        :class="menuItem.subTextClass"
      >
        {{ menuItem.subText }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.currently-selected * {
  @apply font-bold;
}
</style>
